//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useContext, useEffect, useState} from 'react';
import { useParams   } from 'react-router';
import { useLocation, useNavigate } from "react-router-dom";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Tooltip,
} from '@mui/material';
import { ArrowBack, Save } from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {Spacer} from 'components/Spacer';
import { ExpressionContext } from '../ExpressionContext/ExpressionContext';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

// === API ===
import { sendMessageData } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function HeaderRuleView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme       = useTheme();
  const navigate    = useNavigate();
  const { state   } = useLocation();
  const { rule_id } = useParams();

  const { rule, expressions, predicates, save, is_saved } = useContext( ExpressionContext );

  //#endregion

  //#region [STYLES]

  const _styles = {
    button_save: {
      height: '40px',
      margin: '0 6px',
    },
    button_close: {
      height: '40px',
      margin: '0 6px',
    },
  }

  const tooltip_font_large = {
    slotProps: {
      tooltip: {
        sx: {
          fontSize: '14px', // Set your custom size here
        },
      },
    }
  }

  const BUTTON_SAVE = {
    name     : 'da_save_rule_btn', 
    sx       : _styles.button_save,
    variant  : 'contained',
    color    : 'primary',
    children : <Save fontSize='large' />,
    onClick  : onClick_Save,
  };

  const BUTTON_CLOSE = {      
    name     : 'da_close_rule_view_btn',
    sx       : _styles.button_close,
    variant  : 'contained',
    color    : 'error',
    onClick  : onClick_Cancel,
    children : <ArrowBack fontSize='large' />,
  };

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
  }, [] )

  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onClick_Save() {
    //-----------------------------------------------------------------
    const tags_new = { ...rule.tags };

    const update = {
      id          : rule.id     ,
      is_active   : rule.is_active ? 1 : 0,
      description : rule.description ,
      tags        : tags_new    ,
      predicates  : predicates .map( x => x.data ) ,
      expressions : expressions.map( x => x.data ) ,
    }
    if( state?.type === 'template' || update.tags.is_template ) {
      delete update.predicates;
      update.tags.is_template = true;
    }
    
    const type = rule_id === 'new' ? 'RULE_CREATE' : 'RULE_UPDATE';
    sendMessageData( type, { rule: update } );

    save();
  }

  //-----------------------------------------------------------------
  function onClick_Cancel() {
    //-----------------------------------------------------------------
    if( is_saved || window.confirm('Data is not saved. Leave the page?') ) {
      navigate( '/analytics/rules', { replace: true } );
    }
  }

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[ {display: 'flex'}, {alignItems:'center'}]}>
        <Spacer push_right />
        <Tooltip title='Save rule' { ...tooltip_font_large } >
          <Button { ...BUTTON_SAVE } />
        </Tooltip>
        <Tooltip title="Go Back" { ...tooltip_font_large } >
          <Button { ...BUTTON_CLOSE } />
        </Tooltip>
        <Spacer />
      </Styled>
    )
  }

  //#endregion

  return display();
}
